// client/src/components/EditPOI_parts/MovePOIModal.js
import React, { useEffect, useMemo } from "react";

export default function MovePOIModal({
  open,
  poi,
  onSave,
  onCancel,
  saving = false,
}) {
  const poiId = useMemo(() => {
    const v = poi && (poi.id ?? poi.poi_id ?? poi.poiId ?? poi.ID ?? null);
    const n = Number(v);
    return Number.isFinite(n) && n > 0 ? n : null;
  }, [poi]);

  useEffect(() => {
    if (!open) return;

    try {
      window.__PA_POI_MOVE_ACTIVE__ = true;
    } catch {}

    try {
      window.dispatchEvent(
        new CustomEvent("pa-poi-move-ui-open", {
          detail: { poiId, poi },
        })
      );
    } catch {}

    return () => {
      try {
        window.__PA_POI_MOVE_ACTIVE__ = false;
      } catch {}

      try {
        window.dispatchEvent(
          new CustomEvent("pa-poi-move-ui-close", {
            detail: { poiId, poi },
          })
        );
      } catch {}
    };
  }, [open, poiId, poi]);

  if (!open) return null;

  const barStyle = {
    position: "fixed",
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 5000,
    padding: "10px 12px",
    background: "rgba(20,20,22,0.95)",
    borderTop: "1px solid rgba(255,255,255,0.12)",
    boxShadow: "0 -8px 22px rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 10,
    pointerEvents: "auto",
    touchAction: "manipulation",
  };

  const leftInfoStyle = {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    minWidth: 0,
  };

  const titleStyle = {
    fontWeight: 900,
    fontSize: 13,
    color: "#fff",
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const subStyle = {
    fontSize: 12,
    opacity: 0.85,
    color: "#fff",
    lineHeight: 1.2,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  };

  const btnRowStyle = {
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexShrink: 0,
  };

  const btnStyleBase = {
    border: "none",
    borderRadius: 10,
    padding: "10px 14px",
    fontWeight: 900,
    fontSize: 14,
    cursor: "pointer",
    height: 40,
    minWidth: 110,
    pointerEvents: "auto",
  };

  const cancelStyle = {
    ...btnStyleBase,
    background: "#3a3a3a",
    color: "#fff",
    cursor: saving ? "not-allowed" : "pointer",
    opacity: saving ? 0.85 : 1,
  };

  const saveStyle = {
    ...btnStyleBase,
    background: saving ? "#2f7a34" : "#4cc153",
    color: "#101314",
    cursor: saving ? "not-allowed" : "pointer",
    opacity: saving ? 0.85 : 1,
  };

  const name = String(poi?.poi_name ?? poi?.name ?? "").trim() || "POI";

  const stopBubbleOnly = (e) => {
    try {
      e.stopPropagation();
    } catch {}
  };

  return (
    <div
      style={barStyle}
      onPointerDown={stopBubbleOnly}
      onMouseDown={stopBubbleOnly}
      onTouchStart={stopBubbleOnly}
      onClick={stopBubbleOnly}
    >
      <div style={leftInfoStyle}>
        <div style={titleStyle}>Move POI</div>
        <div style={subStyle}>
          {name}
          {poiId ? ` (#${poiId})` : ""}
        </div>
      </div>

      <div style={btnRowStyle}>
        <button
          type="button"
          style={cancelStyle}
          disabled={saving}
          onClick={(e) => {
            stopBubbleOnly(e);
            if (saving) return;
            try {
              if (typeof onCancel === "function") onCancel();
            } catch {}
          }}
        >
          Cancel
        </button>

        <button
          type="button"
          style={saveStyle}
          disabled={saving}
          onClick={(e) => {
            stopBubbleOnly(e);
            if (saving) return;
            try {
              if (typeof onSave === "function") onSave();
            } catch {}
          }}
        >
          {saving ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
}
